<template>
  <article class="view-invoice-page">
    <div class="heading">
      <AppLogo class="heading-logo"></AppLogo>

      <div class="heading-text-group">
        <h1 class="heading-title">Mộc Châu Island</h1>
        <div class="heading-caption">Mường Sang - Mộc Châu - Sơn La</div>
        <div class="heading-caption-group">
          <div class="heading-caption">Tel: 1900 2829</div>
          <div class="divider vertical"></div>
          <div class="heading-caption">Fax: 0212 3768 768</div>
        </div>
        <div class="heading-caption-group">
          <div class="heading-caption">Email: info@mocchauisland.com</div>
          <div class="divider vertical"></div>
          <div class="heading-caption">Website: mocchauisland.com</div>
        </div>
      </div>
    </div>
    <div class="hr"></div>
    <div class="title-form">
      <h1 v-if="subBookingGroupId" class="heading-title">Chi tiết hóa đơn</h1>
      <h1 v-else-if="transactionId" class="heading-title">Chi tiết Folio</h1>
      <p class="heading-caption">
        Thời gian in: {{ $moment().format('HH:mm DD/MM/YYYY') }}
      </p>
    </div>
    <div class="invoice-info-item" style="margin-bottom: 10px">
      <span class="item-label">Công ty: </span
      >{{ (customerInfo.company || info.agent_name) ?? '' }}
    </div>

    <div class="section-invoice-info">
      <div>
        <div class="invoice-info-item">
          <span class="item-label">Tên khách: </span
          >{{ (customerInfo.name || info.customer_name) ?? '' }}
        </div>
        <div class="invoice-info-item">
          <span class="item-label">Số điện thoại: </span
          >{{ (customerInfo.phone_number || info.phone_number) ?? '' }}
        </div>
        <div class="invoice-info-item">
          <span class="item-label">Ngày nhận phòng: </span
          >{{ (customerInfo.from || info.arrive_date) ?? '' }}
        </div>
        <div class="invoice-info-item">
          <span class="item-label">Ngày trả phòng: </span
          >{{ (customerInfo.to || info.depart_date) ?? '' }}
        </div>
      </div>
      <div class="section-invoice-info-right">
        <div class="invoice-info-item">
          <span class="item-label">Loại tiền:</span> VND
        </div>
        <div class="invoice-info-item">
          <span class="item-label">Người in: </span
          >{{ printer?.full_name ?? '' }}
        </div>
        <div
          class="invoice-info-item"
          style="font-weight: 600; font-size: 16pt; margin-top: 15px"
        >
          {{ folio }}
        </div>
      </div>
    </div>
    <div class="hr_invoice-info"></div>
    <div v-for="(service, index) in services" :key="index">
      <div
        class="margin-hr"
        style="text-transform: capitalize; font-size: 13px; font-weight: 600"
      >
        {{ service.transaction_name }}
      </div>
      <div class="hr"></div>
      <div class="margin-hr">
        <table v-if="service.transaction_type === 0" class="table-transaction">
          <thead>
            <tr>
              <th>STT</th>
              <th>Ngày</th>
              <th>Số phòng</th>
              <th>Mã</th>
              <th>Tên sản phẩm</th>
              <th>Đơn giá</th>
              <th>Số lượng</th>
              <th>Giảm giá</th>
              <th>Thành tiền</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(transaction, index) in service.transactions"
              :key="index"
            >
              <td>{{ index + 1 }}</td>
              <td>
                {{ $moment(transaction.trans_date).format('DD/MM/YYYY') }}
              </td>
              <td>{{ transaction.room_num }}</td>
              <td class="code">{{ transaction.code }}</td>
              <td>{{ transaction.name }}</td>
              <td class="text-right">
                {{ Intl.NumberFormat().format(transaction.unit_price) }}
              </td>
              <td class="text-right">
                {{ Intl.NumberFormat().format(transaction.quantity) }}
              </td>
              <td class="text-right">
                {{ Intl.NumberFormat().format(transaction.discount) }}
              </td>
              <td class="text-right">
                {{ Intl.NumberFormat().format(transaction.price) }}
              </td>
            </tr>
          </tbody>
        </table>
        <table v-if="service.transaction_type === 1" class="table-transaction">
          <thead>
            <tr>
              <th>STT</th>
              <th>Ngày</th>
              <th>Số phòng</th>
              <th>Mã</th>
              <th>Tên sản phẩm</th>
              <th>Đơn giá NL</th>
              <th>Số lượng</th>
              <th>Đơn giá TE</th>
              <th>Số lượng</th>
              <th>TE&#60;5t</th>
              <th>Thành tiền</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(transaction, index) in service.transactions"
              :key="index"
            >
              <td>{{ index + 1 }}</td>
              <td>
                {{ $moment(transaction.trans_date).format('DD/MM/YYYY') }}
              </td>
              <td>{{ transaction.room_num }}</td>
              <td class="code">{{ transaction.code }}</td>
              <td>{{ transaction.name }}</td>
              <td class="text-right">
                {{ Intl.NumberFormat().format(transaction.adult_price) }}
              </td>
              <td>
                {{ Intl.NumberFormat().format(transaction.adult_quantity) }}
              </td>
              <td class="text-right">
                {{ Intl.NumberFormat().format(transaction.child_price) }}
              </td>
              <td>
                {{ Intl.NumberFormat().format(transaction.child_quantity) }}
              </td>
              <td>
                {{ Intl.NumberFormat().format(transaction.infant_quantity) }}
              </td>
              <td class="text-right">
                {{ Intl.NumberFormat().format(transaction.price) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="hr"></div>
    </div>
    <div
      class="margin-hr"
      style="display: flex; justify-content: space-between"
    >
      <span style="font-size: 12pt; font-weight: 600">Thành tiền</span>
      <span>{{ total_money }}</span>
    </div>
    <div class="hr"></div>

    <div class="section-signature">
      <div class="flex flex-col justify-start item-center gap-1">
        <span>Khách hàng</span>
        <span style="font-style: italic; font-size: 10px"
          >(Ký ghi rõ họ tên)</span
        >
      </div>
      <div class="flex flex-col justify-start item-center gap-1">
        <span>Chữ ký thu ngân</span>
        <span style="font-style: italic; font-size: 10px"
          >(Ký ghi rõ họ tên)</span
        >
      </div>
    </div>
  </article>
</template>
<script>
import { getFolioDetail } from '@/api/cashier_service/room-transaction'
import { getUserDetailApi } from '@/api/profile/profile'
import AppLogo from '@/components/AppLogo.vue'
import { formatVND } from '@/utils/commonUtils'
// import InfoList from '@/components/info-list/InfoList.vue'
// import InfoListInput from '@/components/info-list/InfoListInput.vue'
// import InfoListLabel from '@/components/info-list/InfoListLabel.vue'
export default {
  components: {
    AppLogo
  },

  data() {
    return {
      isView: false,
      transactionId: null,
      subBookingGroupId: null,
      printer: null,
      customerInfo: {
        company: null,
        name: null,
        phone_number: null,
        from: null,
        to: null
      },
      folio: null,
      transaction_name: null,
      // transaction_type: 0,
      total_money: null,
      summary: {
        money: 0,
        deposit: 0,
        payment: 0,
        paid: 0,
        unpaid: 0
      },

      services: [],
      info: {
        agent_name: null,
        customer_name: null,
        address: null,
        arrive_date: null,
        depart_date: null
      }
    }
  },
  created() {},
  async mounted() {
    this.transactionId = this.$route.query.id
    this.subBookingGroupId = this.$route.query.subBookingGroupId
    // this.folio = this.$route.query.folio
    // this.customerInfo.name = this.$route.query.name
    // this.customerInfo.company = this.$route.query.company
    // this.customerInfo.from = this.$route.query.from
    // this.customerInfo.to = this.$route.query.to
    // this.customerInfo.phone_number = this.$route.query.phone
    if (this.$route.query.isView) {
      this.isView = true
    }
    // if(this.subBookingGroupId){

    // }
    // else if(this.transactionId){

    // }
    await getFolioDetail({
      id: this.transactionId,
      subBookingGroupId: this.subBookingGroupId
    }).then(res => {
      console.log('ledoan', res.data)
      this.services = res.data.map(item => {
        return {
          transaction_name: item.transaction_name,
          transaction_type: item.type || 0,
          transactions: item.data
        }
      })
      this.folio = res.data[0]?.folio_num
      this.customerInfo.name = res.data[0]?.customer_name
      this.customerInfo.company = res.data[0]?.agent_name
      this.customerInfo.from = res.data[0]?.arrive_date
      this.customerInfo.to = res.data[0]?.depart_date
      this.customerInfo.phone_number = res.data[0]?.customer_phone_number
      // this.transaction_name = res.data[0]?.transaction_name
      // this.transaction_type = res.data[0]?.type || 0
      this.total_money = formatVND(res.data[0]?.total_money)
    })

    await getUserDetailApi().then(res => {
      this.printer = res.data.user
    })

    if (!this.isView) {
      this.$nextTick(() => {
        window.print()
      })
    }
  }
}
</script>
<style>
@media print {
  * {
    overflow: visible !important;
  }
  .view-invoice-page {
    max-width: unset;
  }
}
</style>
<style scoped>
.view-invoice-page {
  max-width: 200mm;
  margin: 0 auto;
}
body {
  overflow: hidden !important; /* Hide scrollbars */
}
table,
td,
th,
tr,
thead {
  border: none !important;
}
* {
  font-size: 10pt;
}
thead th {
  font-weight: 500;
  text-align: center;
}

/* table td,
table th {
  padding-left: 0 !important;
  padding-right: 0 !important;
} */

.section-invoice-info {
  display: grid;
  grid-template-columns: 75% 25%;
  margin-bottom: 20px;
}
.section-invoice-info-right {
  text-align: right;
}
.invoice-info-item {
  display: block;
  margin-top: 0.5rem;
}

.invoice-info-item .item-label {
  font-weight: 600;
}

.invoice-info-item:first-child {
  margin-top: 0;
}
.section-signature {
  page-break-inside: avoid;
  min-height: 80pt;
  margin-top: 40pt;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
.hr {
  /* margin-top: 8pt;
  margin-bottom: 16pt; */
  border-top: 0.5pt solid #e5e7eb !important;
}
.hr_invoice-info {
  /* margin-top: 16pt;
  margin-bottom: 16pt; */
  border-top: 0.5pt solid hwb(240 45% 55%) !important;
}
.margin-hr {
  margin-top: 20px;
  margin-bottom: 10px;
}
.section-summary td {
  border: none;
  padding-top: 0 !important;
}

.section-summary tr:last-child td {
  padding-bottom: 0 !important;
}

.section-summary {
  width: fit-content;
  margin-left: auto;
}
.section-summary-right {
  margin-right: auto;
}
table td.text-right {
  text-align: right;
}
table th {
  color: black;
  text-align: center;
  border: none;
}
table thead {
  background-color: unset;
}

table td:last-child {
  padding-right: 0 !important;
}
.title-form {
  margin-top: 20px;
  .heading-title {
    text-align: center;
  }
  .heading-caption {
    text-align: center;
    color: black;
    font-size: 10pt;
    font-style: italic;
  }
}
.section-summary td:first-child {
  font-weight: 500;
  font-size: 10pt;
  text-align: left;
}

.section-summary td:last-child {
  text-align: right;
  padding-left: 20pt !important;
}
.section-summary td {
  height: 25px;
}

.divider.vertical {
  height: 10pt;
  flex-shrink: 0;
  width: 0;
  border-left: 1px solid rgb(156 163 175);
}

.heading-title {
  margin: 0;
  margin-bottom: 8pt;
  font-size: 20pt;
  font-weight: 600px;
  text-transform: uppercase;
}
.heading-caption-group {
  display: flex;
  margin-top: 4pt;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  gap: 6pt;
}
.heading-caption {
  color: rgb(156 163 175);
}
.heading-text-group {
  text-align: center;
  height: fit-content;
}
.heading {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  margin-bottom: 20px;
}

.heading-logo {
  height: 120pt;
  width: auto;
}

.table-transaction {
  /* td,
  th {
    padding: 0 2px;
  } */
  td.code {
    word-break: break-all;
  }
}

.table-payments,
.table-transactions {
  border-collapse: collapse;
}
.table-payments td,
.table-transactions td,
.table-payments th,
.table-transactions th {
  border: 1px solid black !important;
  padding: 6pt !important;
}
.table-transactions .text-right,
.table-payments .text-right {
  text-align: right;
}
.table-transactions td:last-child,
.table-payments td:last-child {
  padding-right: 6pt !important;
}
.item-center {
  align-items: center;
}
</style>
